import * as React from 'react';
import s from '../../Cycles/Cycles.scss';
import classNames from 'classnames';
import {
    PremiumCurrencyFormatter,
    CurrencyAndFormatToString,
} from '@wix/premium-react-text';
import { Text } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import { CycleDetails } from 'types';
import { calculateCycleRevShare } from 'utils';
import { RevShareData } from '@wix/package-picker-common';

export interface RevShareBadgeProps {
    isCycleSelected: boolean;
    cycle: CycleDetails;
    revShareData?: RevShareData;
    productId?: string;
}

export const RevShareBadge: React.FunctionComponent<RevShareBadgeProps> = ({
    isCycleSelected,
    cycle,
    revShareData,
    productId,
}: RevShareBadgeProps) => {
    if (!revShareData || !productId) {
        return null
    }

    const amountEarned = calculateCycleRevShare({ cycle, revShareData, productGuid: productId });

    if (amountEarned === 0) {
        return null;
    }
    return (
        <PremiumCurrencyFormatter
            currencySettingsOverride={{ fractionSize: 2 }}
            render={(formatCurrency) => (
                <RevShareBadgeContent
                    formatCurrency={formatCurrency}
                    isCycleSelected={isCycleSelected}
                    amountEarned={amountEarned}
                />
            )}
        />
    );
};

const RevShareBadgeContent: React.FC<{
    formatCurrency: CurrencyAndFormatToString;
    isCycleSelected: boolean;
    amountEarned: number;
}> = ({ amountEarned, isCycleSelected, formatCurrency }) => {
    const discountBadgeClassNames = classNames(s.discountBadge, s.revShareBadge, {
        [s.cycleSelected]: isCycleSelected
    });
    const { t } = useTranslation();
    return (
        <div className={discountBadgeClassNames} data-hook='rev-share-badge'>
            <Text
                size='small'
                weight='bold'
                className={s.badgeText}
                light={isCycleSelected}
                skin={isCycleSelected ? 'standard' : 'premium'}
                dataHook='rev-share-badge-text'
            >
                {t('cycle_entry.revshare_amount.label', {
                    amountEarned: formatCurrency(amountEarned)
                })}
            </Text>
        </div>
    );
};
